import { tsv } from "@faire/slate/lib/tsv";
import React from "react";

type IProps = React.RefAttributes<HTMLDivElement> &
  React.HTMLAttributes<HTMLDivElement>;

export const ModalHeaderBase: React.FC<React.PropsWithChildren<IProps>> = ({
  children,
  className,
  ...props
}) => {
  return (
    <div {...props} className={headerStyle.cls({ className })}>
      {children}
    </div>
  );
};

const headerStyle = tsv({
  base: "fs-modal__header",
});
